import { ImageType, Product, ProductType } from '@inter-ikea-storageone/range';
import {
  getDefaultHoverImage,
  getFPPImage,
  getMPPImage,
  getProductImage,
  getQPPImage
} from 'products';

export const getPanelMainImage = (product: Product) => {
  const productImageMeta = product.meta?.productImage;
  return productImageMeta
    ? getProductImage(product, ImageType[productImageMeta.type], productImageMeta.index)
    : getQPPImage(product);
};

export const getPanelHoverImage = (product: Product) => {
  return getMPPImage(product) || getFPPImage(product);
};

export const getAccessoryHoverImage = (product: Product) => {
  return product.type === ProductType.PAX_DRAWER_MAT
    ? getQPPImage(product) || getFPPImage(product)
    : getDefaultHoverImage(product);
};
